import { types } from './mutation-types.js';

let mutations = {}
Object.keys(types).forEach((key) => {
    mutations[key] = function (state,value) {
        state[types[key]] = value
    }
})

export default mutations